import Button from 'components/Button'
import { FilterText } from 'components/FilterDiv'
import { StyledTable } from 'components/TableStyles/TableStyles'
import DriveFilter from 'modules/Dashboard/Partials/DashboardDrive/Partials/DriveInfoTable/Partials/DriveFilter'
import DriveStatus from 'modules/Dashboard/Partials/DashboardDrive/Partials/DriveInfoTable/Partials/DriveStatus'
import {
  NavWrapper,
  StyledP,
  TableTop,
} from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Style/style'
import moment from 'moment'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getIdFormate } from 'utils/getZeroBeforeInt'

const DriveInfoTable = ({
  rolesList,
  updateRoleData,
  setJobId,
  setUrl,
  currentUrl,
  setCurrentPage,
  currentPage,
  getJobDetails,
  corporateAboutUs,
  onAcceptOrRejectClick,
  onSortValueChanged,
  loading = false,
  citiesList,
  getCities,
  dashboardDriveSingleList,
  search,
  setSearch,
  setFilterQuery,
}) => {
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  const navigate = useNavigate()

  const getDriveMode = driveMode => {
    return driveMode?.toLowerCase().replace('_', ' ')
  }

  const columns = [
    {
      title: 'Drive',
      dataIndex: '',
      render: (text, item) => <StyledP>{getIdFormate(item?.id)}</StyledP>,
    },
    {
      title: 'drive STATUS',
      render: (text, item) => <DriveStatus status={item?.corporateStatus} />,
    },
    {
      title: 'drive type',
      render: (text, data) => (
        <StyledP>{getDriveMode(data?.driveMode)}</StyledP>
      ),
    },
    {
      title: 'Drive start date',
      sorter: true,
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('startDate')
          },
        }
      },
      render: (text, data) => (
        <StyledP>{moment(data?.startDate).format('DD/MM/YYYY')}</StyledP>
      ),
    },
    {
      title: 'Drive end date',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => (
        <StyledP>{moment(data?.endDate).format('DD/MM/YYYY')}</StyledP>
      ),
    },
    {
      title: 'Students applied',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <StyledP>{data?.appliedCandidate}</StyledP>,
    },
    {
      title: 'Students hired so far',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <StyledP>{data?.hiredCandidate}</StyledP>,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      render: (text, item) => (
        <Button.Secondary
          text="View"
          onClick={() => {
            actionClicked(item)
          }}
        />
      ),
    },
  ]
  const actionClicked = data => {
    navigate(
      `/dashboard/roles/drive/${data?.id}/${data?.roleID}?stage=all_candidates`
    )
  }

  const paginationChange = (page, pageSize) => {
    setUrl(`${currentUrl}`)
    setCurrentPage(page - 1)
  }
  const sortFilter = sort => {
    let sortOrder = ''
    if (sort == sortBy) {
      sortOrder = orderBy == 'asc' ? 'desc' : 'asc'
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
    onSortValueChanged(`sort=${sort}&order=${sortOrder}`)
  }
  const changeFilters = filter => {
    setUrl(`${filter}`)
    setCurrentPage(1)
  }
  return (
    <NavWrapper column>
      <TableTop centerVertically>
        <DriveFilter
          setFilterQuery={setFilterQuery}
          setQuery={changeFilters}
          citiesList={citiesList}
          getCities={getCities}
        />
        <FilterText>
          Showing{' '}
          {10 * (currentPage - 1) + dashboardDriveSingleList?.result?.length} of{' '}
          {dashboardDriveSingleList?.count}
        </FilterText>
      </TableTop>
      <StyledTable
        columns={columns}
        loading={loading}
        dataSource={dashboardDriveSingleList?.result}
        pagination={{
          defaultPageSize: 10,
          current: currentPage + 1,
          onChange: (page, pageSize) => {
            paginationChange(page, pageSize)
          },
          total: dashboardDriveSingleList?.count,
        }}
      />
    </NavWrapper>
  )
}

export default DriveInfoTable
